import { createAsyncThunk } from '@reduxjs/toolkit'
import { ApiError } from '@user/store/agreements/typings'
import { UpcomingFollowUpsData, UpcomingFollowUpsInput } from './typings'
import { get, post } from '@user/store/services/crud'
import { ServiceConfig } from '@user/store/services/config'
import { IUserPreferenceDashboard } from '@user/store/userPreferences/typings'

export const getData = createAsyncThunk<
  UpcomingFollowUpsData,
  void,
  { rejectValue: ApiError }
>('dashboard/upcomingFollowUps/getData', async (_, thunkApi) => {
  const response = await get(`${ServiceConfig.baseAPIUrl}/Dashboard/followUps`)

  if (response.ok) {
    const payload: UpcomingFollowUpsData = await response.json()
    return payload
  }
  return thunkApi.rejectWithValue((await response.json()) as ApiError)
})

export const postData = createAsyncThunk<
  IUserPreferenceDashboard,
  UpcomingFollowUpsInput
>(
  'usersPreferences/Dashboard/upcomingFollowUps/post',
  async (userPref, thunkApi) => {
    const response = await post(
      `${ServiceConfig.baseAPIUrl}/UserPreferences/dashboard`,
      userPref,
    )
    if (response.ok) {
      const result: IUserPreferenceDashboard = await response.json()
      return result
    }
    return thunkApi.rejectWithValue(await response.json())
  },
)
